import { ModuleTrialRequestsState } from '@core/module-trial-requests/store/states/module-trial-requests.state';

export const moduleTrialRequestsState = [ModuleTrialRequestsState];
